export const PRESENCE_SNAPSHOT = "PRESENCE_SNAPSHOT";
export const PRESENCE_UPDATE = "PRESENCE_UPDATE";
export const PRESENCE_LEASE_EXPIRED = "PRESENCE_LEASE_EXPIRED";
export const PRESENCE_CLEAR = "PRESENCE_CLEAR";

/** Must match backend PRESENCE_HEARTBEAT_INTERVAL_SECONDS. */
export const PRESENCE_HEARTBEAT_INTERVAL_MS = 30_000;

/** Max user ids per presence_subscribe (server also enforces). */
export const PRESENCE_SUBSCRIBE_MAX_IDS = 50;
